import React from 'react'
import sssImg from "../../assets/images/sss.svg"
import { Link } from 'react-router-dom'

const SSS = () => {
    const openInNewTab = (url:any) => {
        window.open(url, "_blank", "noopener,noreferrer");
    }
  return (
    <div>
        <img src={sssImg} alt="sss" />
    </div>
  )
}

export default SSS